import styled, { css } from 'styled-components';
import { layout } from '@prisjakt/ui-base';
import CountryFlagComponent from '@prisjakt/ui-country-flag';

export const LocationAndCurrencyInfo = styled.div`
  display: flex;
`;

type TextProps = {
  textSize?: 'small' | 'normal';
};

export const Text = styled.p<TextProps>(
  props => css`
    display: flex;
    align-items: center;
    color: ${props.theme.text.secondary};
    margin: 0;

    ${props.textSize === 'small' &&
      css`
        font-size: ${layout.measurements.fontSizeSmall};
        color: ${props.theme.text.tertiary};
      `}
  `
);

export const CountryFlag = styled(CountryFlagComponent)`
  display: block;
  margin-right: ${layout.spacing.xxSmall};

  img {
    height: auto;
  }
`;
